import { Link } from 'react-router-dom';
import {
  Icon,
  Inline,
  InlineItem,
  Strong,
  UtilityButton,
} from '@kinesis/bungle';
import { InterventionCategory } from '@/types';
import { renderInterventionCategory } from '@/data/labels';
import { useNewInterventionCategory } from '@/hooks/use-new-intervention-category';

const icons = {
  energy: 'waterfall-filled',
  transport: 'car-filled',
  waste: 'delete-filled',
  ippu: 'attributes-filled',
  agriculture: 'table-filled',
  forestry: 'map-filled',
  development: 'building-filled',
};

const CategoryHeader = (props: CategoryHeaderProps) => {
  const category = useNewInterventionCategory();
  return (
    <Inline space='small'>
      <InlineItem sizing='fit-content'>
        <Icon
          type={icons[props.category] ?? 'waterfall-filled'}
          color='rgba(0,0,0,0.45)'
        />
      </InlineItem>
      <InlineItem sizing='fill-container'>
        <Strong>{renderInterventionCategory(props.category)}</Strong>
      </InlineItem>

      <InlineItem sizing='fit-content'>
        <UtilityButton
          magnitude='small'
          as={Link}
          to={
            category === props.category
              ? props.detailPath
              : `${props.detailPath}/interventions/new/${props.category}`
          }
          icon='add-location'
          variant={category === props.category ? 'accent' : 'secondary'}
        />
      </InlineItem>
    </Inline>
  );
};
export type CategoryHeaderProps = {
  // The owning detail page's absolute path (see the sidebar).
  detailPath: string;
  category: InterventionCategory;
};

export { CategoryHeader };
